import {AppThunk} from '../index';
import {RequestForm} from '../../../shared/models/supportService';
import {PickerResult} from '../../../shared/components/filePicker/model';
import {httpService, HttpWrapperOptions} from '../../../shared/httpWrapper';
import {apiUrls} from '../../../shared/constants/urls';
import {getApiRoute} from '../../../shared/pipes';

export const createRequest =
  (form: RequestForm, files: PickerResult[]): AppThunk =>
  async () => {
    const data = new FormData();
    data.append('text', form.text);
    data.append('topic', form.topic);
    data.append('themeId', form.themeId.toString());
    if (files && files.length) {
      files.forEach((file) => {
        data.append('file', file.file as any);
      });
    }

    await httpService.post<RequestForm>(
      getApiRoute(apiUrls.createRequest),
      data,
      new HttpWrapperOptions().Wait(true).ThrowException(true).Timeout(300000), // 5 min
    );
  };
